<div class="main">
    <div class="d-grid two-grid-c grid-center h-100 justify-center align-center">
        <div class="main-login-box">
            @if(showLogin){
                <div class="login-box">
                    <div class="logo">
                        <img src="assets/svg/logo.svg" alt="">
                    </div>
                    <div class="text-center align-self-center">
                        <h4 class="welcome-title">Bienvenido/a</h4>
                    </div>
                    <div>
                        <label class="login-label" for="">Correo electr&oacute;nico</label>
                        <input class="login-input" type="email" name="email" id="email" [(ngModel)]="user">
                    </div>
                    <div>
                        <label class="login-label" for="">Contrase&#241;a</label>
                        <input class="login-input" type="password" name="pass" id="pass" [(ngModel)]="pass">
                        @if(invalidCreds){
                            <h4 class="color-org">Credenciales inv&aacute;lidas.</h4>
                        } 
                    </div>
                    <div>
                        <button class="btn-login" (click)="userLogin()"> Iniciar Sesi&oacute;n</button>
                    </div>
                    <div class="text-center">
                        <input class="check-login" type="checkbox" name="" id="">
                        <label class="login-label" for="">Mantener sesion iniciada en este equipo</label>
                        <div class="mt-4"><a (click)="getRecover()">Olvid&eacute; mi contrase&#241;a</a></div>
                    </div>
                </div>
            }

            @if(showRecover && !showMessage){
                <div class="login-box">
                    <div class="logo">
                        <img src="assets/svg/logo.svg" alt="">
                    </div>
                    <div class="text-center align-self-center">
                        <h4 class="welcome-title">Restablecer contrase&#241;a</h4>
                    </div>
                    <div>
                        <h4 class="text-center text-light t-16">Ingresa tu correo electr&oacute;nico y te enviaremos un <br> enlace para restablecer tu contrase&#241;a</h4>
                    </div>
                    <div>
                        <label class="login-label" for="">Correo electr&oacute;nico</label>
                        <input class="login-input" type="text" name="email" id="email" [(ngModel)]="recoverMail">
                    </div>
                    <div>
                        <button class="btn-login" (click)="userRecover()">Restablecer contrase&#241;a</button>
                    </div>
                    <div>
                        <button class="btn-login-outline" (click)="getLogin()">Cancelar</button>
                    </div>
                </div>
            }

            @if(showMessage && !showVerification){
                <div class="login-box">
                    <div class="logo">
                        <img src="assets/svg/logo.svg" alt="">
                    </div>
                    <div class="text-center align-self-center">
                        <h4 class="welcome-title">Restablecer contrase&#241;a</h4>
                    </div>
                    <div>
                        <h4 class="text-center text-light t-16">Te hemos enviado un correo electr&oacute;nico con instrucciones <br> para restablecer tu contrase&#241;a</h4>
                    </div>
                </div>
            }

            @if(showVerification && !showResetPassword){
                <div class="login-box">
                    <div class="logo">
                        <img src="assets/svg/logo.svg" alt="">
                    </div>
                    <div class="text-center align-self-center">
                        <h4 class="welcome-title">Restablecer contrase&#241;a</h4>
                    </div>
                    <div class="verification-section">
                        <h4 class="text-center text-light t-16 mb-3">Introduce el código de 6 dígitos que enviamos a tu <br> correo electrónico para verificar tu identidad.</h4>
                        
                        <div class="verification-inputs d-flex justify-content-center gap-2 mb-3">
                            @for (digit of verificationCode; track $index) {
                                <input 
                                    type="text" 
                                    class="verification-input text-center" 
                                    maxlength="1" 
                                    [attr.data-index]="$index"
                                    [value]="digit"
                                    (input)="onCodeInput($index, $event)"
                                    (keydown)="onCodeKeydown($index, $event)"
                                />
                            }
                        </div>
                        
                        <p class="text-center text-light t-14 mb-4">
                            Si no lo recibes en unos minutos, revisa tu carpeta <br> de spam o vuelve a solicitarlo.
                        </p>
                        
                        <div class="d-flex flex-column gap-2">
                            <button class="btn-login" (click)="verifyCode()">Verificar código</button>
                            <button class="btn-login-outline" (click)="cancelVerification()">Cancelar</button>
                        </div>
                    </div>
                </div>
            }

            @if(showResetPassword){
                <div class="login-box">
                    <div class="logo">
                        <img src="assets/svg/logo.svg" alt="">
                    </div>
                    <div class="text-center align-self-center">
                        <h4 class="welcome-title">Restablecer contraseña</h4>
                    </div>
                    <div>
                        <h4 class="text-center text-light t-16 mb-4">Ingresa una nueva contraseña para recuperar el <br> acceso a tu cuenta de forma segura.</h4>
                    </div>
                    <div>
                        <label class="login-label" for="">Nueva contraseña</label>
                        <input class="login-input" type="password" name="newPassword" id="newPassword" [(ngModel)]="newPassword">
                    </div>
                    <div>
                        <label class="login-label" for="">Confirmar nueva contraseña</label>
                        <input class="login-input" type="password" name="confirmNewPassword" id="confirmNewPassword" [(ngModel)]="confirmNewPassword">
                    </div>
                    
                    <!-- Validaciones de contraseña -->
                    <div class="password-requirements mt-3">
                        <div class="requirement-item" [class.valid]="hasMinLength()">
                            <span class="requirement-icon">{{hasMinLength() ? '✓' : '•'}}</span>
                            <span class="requirement-text">Al menos 8 caracteres.</span>
                        </div>
                        <div class="requirement-item" [class.valid]="hasUpperCase()">
                            <span class="requirement-icon">{{hasUpperCase() ? '✓' : '•'}}</span>
                            <span class="requirement-text">Una letra mayúscula.</span>
                        </div>
                        <div class="requirement-item" [class.valid]="hasNumber()">
                            <span class="requirement-icon">{{hasNumber() ? '✓' : '•'}}</span>
                            <span class="requirement-text">Un número.</span>
                        </div>
                        <div class="requirement-item" [class.valid]="hasSpecialChar()">
                            <span class="requirement-icon">{{hasSpecialChar() ? '✓' : '•'}}</span>
                            <span class="requirement-text">Un símbolo especial (como @, #, $, *).</span>
                        </div>
                    </div>
                    
                    <div class="mt-4">
                        <button class="btn-login" (click)="resetPassword()" [disabled]="!isPasswordValid()">Restablecer contraseña</button>
                    </div>
                    <div>
                        <button class="btn-login-outline" (click)="cancelPasswordReset()">Cancelar</button>
                    </div>
                </div>
            }

            <div class="text-center mt-5 text-light">
                © 2025 TIC Services. Todos los derechos reservados.
            </div>
        </div>
        <div class="main-img-container">
            <div class="main-login-img">
                <div class="logo">
                    <img src="assets/svg/logo-orange.svg" alt="">
                </div>
            </div>
        </div>
    </div>
</div>